import {useGetHovercardAttributesForType} from '@github-ui/hovercards/use-get-hovercard-attributes-for-type'
import {getAgentAppSlug} from './PullRequestHeaderAuthors'
import {Link} from '@primer/react'
import {clsx} from 'clsx'
import {GitHubAvatar} from '@github-ui/github-avatar'
import {ProfileReference} from '@github-ui/profile-reference'
import styles from './ActorLink.module.css'
import {isCopilot} from '@github-ui/assignees/copilot-user'

export interface ActorLinkProps {
  actor: {
    login: string
    displayName?: string | null
    avatarUrl?: string | null
    isAgent?: boolean
  }
  inline?: boolean
  showAvatar?: boolean
  className?: string
}

export function ActorLink({actor, inline, showAvatar, className}: ActorLinkProps) {
  const getHovercardAttributesForType = useGetHovercardAttributesForType()

  const agentSlug = actor.isAgent || isCopilot(actor.login) ? getAgentAppSlug(actor) : null
  const hovercardAttributes = agentSlug
    ? getHovercardAttributesForType('copilot', {botSlug: agentSlug})
    : getHovercardAttributesForType('user', {login: actor.login})

  return (
    <Link
      muted
      inline={inline}
      className={clsx('text-bold', showAvatar && styles.withAvatar, className)}
      {...hovercardAttributes}
      href={agentSlug ? `/apps/${agentSlug}` : `/${actor.login}`}
    >
      {showAvatar && actor.avatarUrl && <GitHubAvatar src={actor.avatarUrl} alt="" size={20} />}
      <ProfileReference login={actor.login} profileName={actor.displayName} isAgent={actor.isAgent ?? false} />
    </Link>
  )
}
